import React from 'react';
import App from './route';
import {Provider} from 'react-redux';
import {HashRouter as Router} from 'react-router-dom';
import 'moment/locale/zh-cn';
import moment from 'moment';
import {ConfigProvider} from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import * as log from 'loglevel';
import store from './store';
import './tools/sensors';


moment.locale('zh-cn');

/** 根据部署环境来设置log等级,0输出任何日志（测试环境使用），5关闭所有日志（生产环境使用） */
(function setLogLevel() {
    process.env.NODE_ENV === 'production' ? log.setLevel(5) : log.setLevel(0);
})();

const Page = () => (<Provider store={store}>
    <Router>
        <ConfigProvider locale={zh_CN}><App/></ConfigProvider>
    </Router>
</Provider>);
export default Page;
